import React from 'react';

function ErrorPage() {
    return (
        <div className="box-shadow">
            <h5 className="errorText">Something went wrong...</h5>
        </div>
    );
}

export default ErrorPage;


// WEBPACK FOOTER //
// ./src/components/ErrorPage/ErrorPage.js